var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C4.5 0 0.5 0.5 0.5 4V13.5C0.5 14.45 0.88 15.31 1.5 15.94V17.5C1.5 18.33 2.17 19 3 19C3.83 19 4.5 18.33 4.5 17.5V17H12.5V17.5C12.5 18.32 13.17 19 14 19C14.82 19 15.5 18.33 15.5 17.5V15.94C16.12 15.31 16.5 14.45 16.5 13.5V4C16.5 0.5 12.92 0 8.5 0ZM5 14C4.17 14 3.5 13.33 3.5 12.5C3.5 11.67 4.17 11 5 11C5.83 11 6.5 11.67 6.5 12.5C6.5 13.33 5.83 14 5 14ZM12 14C11.17 14 10.5 13.33 10.5 12.5C10.5 11.67 11.17 11 12 11C12.83 11 13.5 11.67 13.5 12.5C13.5 13.33 12.83 14 12 14ZM14.5 8H2.5V5H14.5V8Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusIcon);
export default __webpack_public_path__ + "static/media/BusIcon.fc4bb50b71f1e505db9e12f915ffe709.svg";
export { ForwardRef as ReactComponent };